import React from 'react';
import Modal from 'react-modal';
import {
  ComposableTable,
  getTextCellGenerator,
  getTextWithSubtextCellGenerator,
  getEditCellGenerator,
} from 'components/ComposableTable';
import { CoachRow } from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorPeopleListView';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CoachingUpdateCoachDialog from 'coaching/components/CoachingCoordinatorView/CoachingUpdateCoachDialog';
import Row from 'components/Row';
import ScrollLoadZone from 'components/ScrollLoadZone';
import TimezoneHelper from 'lib/timezones';

export type Props = {
  coaches: CoachRow[];
  loadingCoaches: boolean;
  hasNextPage?: boolean;
  onNextPage: () => Promise<void>;
};

type State = {
  editStatusDialogIsOpen: boolean;
  editCoachUuid?: string;
  statusInput?: string;
};

const columnHeaders = () => {
  return [{ name: 'Name' }, { name: 'Status' }, { name: 'Timezone' }];
};

export default class CoachingCoordinatorCoachList extends React.Component<Props, State> {
  state: State = {
    editStatusDialogIsOpen: false,
  };

  showEditStatusDialog = (coachRow: CoachRow) =>
    this.setState({
      editStatusDialogIsOpen: true,
      editCoachUuid: coachRow.uuid,
      statusInput: coachRow.status,
    });

  hideEditStatusDialog = () =>
    this.setState({
      editStatusDialogIsOpen: false,
      editCoachUuid: undefined,
      statusInput: undefined,
    });

  columnGenerators = (): Array<(data: CoachRow) => React.ReactNode> => {
    return [
      getTextWithSubtextCellGenerator({
        text: 'name',
        subtext: 'uuid',
        textWithSubtextProps: {
          subtle: false,
        },
      }),
      getEditCellGenerator('status', {
        onEdit: this.showEditStatusDialog,
      }),
      getTextCellGenerator(row => TimezoneHelper.convertToReadableShortCode(row.timezone ?? 'UTC')),
    ];
  };

  render() {
    const { coaches } = this.props;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.editStatusDialogIsOpen && !!this.state.editCoachUuid}>
          <CoachingUpdateCoachDialog
            onRequestHide={this.hideEditStatusDialog}
            coachUuid={this.state.editCoachUuid!}
            initialStatus={this.state.statusInput!}
          />
        </Modal>
        <Row>
          <ComposableTable<CoachRow>
            rows={coaches}
            columnHeaders={columnHeaders()}
            columnGenerators={this.columnGenerators()}
            fixedHeader
            keyField="uuid"
          />
        </Row>
        {this.props.loadingCoaches && <CenteredLoadingIndicator />}
        {this.props.hasNextPage && <ScrollLoadZone onZoneActivated={this.props.onNextPage} />}
      </React.Fragment>
    );
  }
}
